
export const webStyle = {
  headerNavLink: {
    color: " #141619",
    cursor: "pointer",
    fontSize: { lg: "18px", xs: "14px" },
    fontWeight: 500,
  },
  btnStyle: {
    ".circle": {
      background: "linear-gradient(100deg, #3359D3 24.76%, #25CED9 117.01%)",
      color: "white",
      borderRadius: "145px",
      //   position: "relative",
      textAlign: "center",
      boxSizing: "border-box",
      border: "10px",
      fontSize: { lg: "16px", xs: "14px" },
      textTransform: "capitalize",
      padding: { lg: "10px 20px 10px 20px", xs: "5px 10px 5px 10px" },
      fontWeight: 400,
    },
    ".circle::before": {
      borderRadius: "145px",
      content: "''",
      backgroundImage: "linear-gradient(to right, #25CED9 30px,#3359D3 100%)",
      top: "-2px",
      left: "-2px",
      bottom: "-2px",
      right: "-2px",
      position: "absolute",
      zIndex: -1,
    },
  },
};
// dropdown custome style
export const styles = {
  control: (provided, state) => ({
    ...provided,
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    borderBottomRightRadius: state.selectProps.menuIsOpen ? "0px" : "10px",
    borderBottomLeftRadius: state.selectProps.menuIsOpen ? "0px" : "10px",
    backgroundColor: "transprant",
    color: "#000",
    transition: "none",
    cursor: "pointer",
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    backgroundColor: "#fff",
    color: isSelected ? "#000" : "#000",
    zIndex: 1,
    cursor: "pointer",
    paddingLeft: "20px",
    borderBottom: "1px solid #FAFAFA",
    transition: "none",
    width: "100%",
    whiteSpace: "nowrap",
    ":hover": {
      backgroundColor: isSelected ? "#D3D3D3" : "#D3D3D3",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100,
    backgroundColor: "#fff",
    paddingTop: "10px",
    paddingBottom: "10px",
    border: "10px solid black",
    width: "fit-content",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : null,
    color: "#000",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000",
    marginLeft: "10px",
  }),
  // placeholder: (provided) => ({
  //   ...provided,
  //   color: "#FAFAFA",
  //   marginLeft: "10px",
  // }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: "0px",
    paddingBottom: "0px",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
    backgroundColor: "#fff",
    borderRadius: "8px", // Example border radius
    padding: "8px",
  }),
};
